import { Box, BoxProps } from '@mui/material';
import { useProjectLogoStyles } from './project-logo.styles';
import { decodeImageURL } from '../../../util/image-url';

export interface ProjectLogoProps extends BoxProps {
  imageURL: string;
  alt?: string;
}

export const ProjectLogo = ({ imageURL, alt, ...rest }: ProjectLogoProps) => {
  const classes = useProjectLogoStyles();

  return (
    <Box className={classes.wrapper} {...rest}>
      <img src={decodeImageURL(imageURL)} alt={alt ?? 'Project logo'} />
    </Box>
  );
};
